import axios from "axios";

export default {
    state: {
        contents: null,
        token: localStorage.getItem('token') || '',
        content: {},
        page: 1,
        filter: 1,
        flexiblePage: 1,
        totalElements: 1,
        sort: '',
        sortType: '',
        lastPage: 0,
        deleteStatus: false
    },
    mutations: {
        updateContents(state, contents) {
            state.contents = contents
        },
        updateDeleteStatus(state, deleteStatus) {
            state.deleteStatus = !state.deleteStatus
        },
        updateContent(state, content) {
            state.content = content
        },
        updatePagePagination(state, page) {
            state.page = page
        },
        updateFilter(state, filter) {
            state.filter = filter
        },
        updateSort(state, sortObj) {
            state.sort = sortObj.sort
            state.sortType = sortObj.sortType
        },
        updateFlexiblePage(state, page) {
            state.flexiblePage = page
        },
        updateTotalElementsPagination(state, total) {
            state.totalElements = total
        },
        setLastPage(state, lastPage) {
            state.lastPage = lastPage
        }
    },
    actions: {
        deleteStatus(ctx){
            ctx.commit('updateDeleteStatus')
        },
        uploadImage({commit}, img) {
            return axios.post(process.env.VUE_APP_API + '/image/upload', {img},
                {
                    headers: {
                        'Authorization':
                            localStorage.getItem('token')
                    }
                }
            )
        },
        contentList(ctx, payload) {
            return new Promise((resolve, reject) => {
                let baseURI = process.env.VUE_APP_API + '/contents/my?page=' + payload.page
                let paramsUri = payload.sort ? '&sort=' + payload.sort + '&type=' + payload.type : '&filter=' + payload.filter;
                axios.get(baseURI + paramsUri, {
                        headers: {
                            'Authorization': localStorage.getItem('token')
                        }
                    }
                )
                    .then(resp => {
                        const contents = resp.data.data

                        localStorage.list = JSON.stringify(resp.data.data);

                        contents.map(item => {
                            return item.date = Date.parse(item.created_at)
                        })
                        ctx.commit('updateContents', contents)
                        ctx.commit('updatePagePagination', resp.data['current_page'])
                        ctx.commit('setLastPage', resp.data['last_page'])
                        ctx.commit('updateFilter', payload.filter)
                        ctx.commit('updateSort', {sort: payload.sort, sortType: payload.type})
                        if (resp.data.data.length === 1) {
                            ctx.commit('updateFlexiblePage', resp.data['current_page'] - 1)
                        } else {
                            ctx.commit('updateFlexiblePage', resp.data['current_page'])
                        }
                        ctx.commit('updateTotalElementsPagination', resp.data.total)
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log(err)
                        ctx.commit('updateContents', {})
                        reject(err)
                    })

            })
        },
        contentById(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API + '/contents/' + payload.id, {full: payload.full ?? false, non_edit: payload.non_edit ?? false},
                    {
                        headers: {
                            'Authorization': localStorage.getItem('token')
                        }
                    }
                )
                    .then(resp => {

                        const content = resp.data
                        ctx.commit('updateContent', content)
                        // console.log(resp)
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log(err.response)
                        resolve({status: err.response.status})
                        // ctx.commit('updateContent', {})
                        // reject(err)
                    })
            })
        },
        contentByName(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API + '/contents/name/' + payload.name, {full: payload.full ?? false},
                    {
                        headers: {
                            'Authorization':
                                localStorage.getItem('token')
                        }
                    }
                )
                    .then(resp => {
                        const content = resp.data
                        ctx.commit('updateContent', content)
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log(err)
                        ctx.commit('updateContent', {})
                        reject(err)
                    })
            })
        },
        contentByTags(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API + '/contents',
                    {
                        full: payload.full ?? false,
                        tag_1: payload.tag_1,
                        tag_2: payload.tag_2
                    },
                    {
                        headers: {
                            'Authorization':
                                localStorage.getItem('token')
                        }
                    }
                )
                    .then(resp => {
                        const content = resp.data
                        ctx.commit('updateContent', content)
                        resolve(resp)
                    })
                    .catch(err => {
                        console.log(err)
                        ctx.commit('updateContent', {})
                        reject(err)
                    })
            })
        }
        ,
        async checkAvailableName({commit}, payload){
            return await axios.post(process.env.VUE_APP_API + '/check-availability-name', {name: payload.name}, {
                headers: {
                    'Authorization': localStorage.getItem('token')
                }
            }).then(resp => {
                if (resp.status === 401) {
                    return false
                }
                return resp.data
            }).catch(error => {
                return error
            })
        },
        createContent({commit}, content) {
            return new Promise((resolve, reject) => {
                axios.post(process.env.VUE_APP_API + '/contents/create', content, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(error => {
                    reject(error)
                })
            })

        },
        updateContent({commit}, content) {
            return new Promise((resolve, reject) => {
                axios.patch(process.env.VUE_APP_API + '/contents/' + content.content.id, content, {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(error => {
                    reject(error)
                })
                // commit('logout')
            })
        },
        async deleteContent({commit}, id) {
            return await axios.delete(process.env.VUE_APP_API + '/contents/' + id, {
                headers: {
                    'Authorization': localStorage.getItem('token')
                }
            }).then(resp => {
                return resp.data
            })
        },
        async changeContentActive({dispatch}, content) {
            return await axios.put(process.env.VUE_APP_API + '/contents/by/' + content.id, {active: content.active}, {
                headers: {
                    'Authorization': localStorage.getItem('token')
                }
            }).then(resp => {
                dispatch('createNotification', {
                    type: 'success',
                    message: `Gate status changed to ${resp?.data?.active ? 'active' : 'non-active'}`})
                return resp.data
            })
        }
    },
    getters: {
        getContents(state) {
            return state.contents
        },
        getDeleteStatus(state) {
            return state.deleteStatus
        },
        getPaginationPage(state) {
            return state.page
        },
        getFilter(state) {
            return state.filter
        },
        getFlexiblePage(state) {
            return state.flexiblePage
        },
        getSort(state) {
            return {
                sort: state.sort,
                type: state.sortType
            }
        },
        getPaginationTotalElements(state) {
            return state.totalElements
        },
        getLastPage(state) {
            return state.lastPage
        }
    },
}
